import styled from 'styled-components';

import { flex } from 'quarks/interpolations/flex';

const Flex = styled.div`
  ${flex}
`;

export default Flex;
